<mh-alerts-wrapper>

  <section mhFilterBar>
    <div mhFilterGroup>
      <div>
        <mh-core-lib-datepicker
          [currentDates]="currentDates"
          [currentFilter]="currentFilterDate"
          (datepickerUpdated)="handleDatepickerUpdated($event)">
        </mh-core-lib-datepicker>
      </div>

      <div mhFilterGroup>
        <!-- Selector de métricas -->
        <mh-index-selector 
          [translationPrefix]="'inter-chain.executive.table'"
          [actions]="filtersData['metrics']"
          [selectedOption]="filterSelected['metrics']"
          (optionSelected)="setSelectValue($event, 'metrics')">
        </mh-index-selector>
        
        <!-- Selector de áreas (solo si está disponible) -->
        <ng-container *ngIf="filterSelected['metrics'] === 'area' && filtersAreas.length > 0">
          <mh-index-selector 
            [translationPrefix]="'areas'"
            [actions]="filtersData['areas']"
            [selectedOption]="filterSelected['areas']"
            [valueType]="'number'"
            (optionSelected)="setSelectValue($event, 'areas')">
          </mh-index-selector>
        </ng-container>
      </div>
    </div>

    <div>
      <mh-filter-date
          [startDate]="startDate"
          [endDate]="endDate"
          [reportActiveEmail]="true"
          [report]="fidelityPermisions.includes('interchain_executive_summary_report') ? 'chainOnlineExecutive' : null"
          [checkPermissions]="true"
          slug="corporative_online_ejecutive_report">
      </mh-filter-date>
    </div>
  </section>

  <mh-box-element [title]="('inter-chain.executive.title' | translate)">

    <mh-core-lib-survey-wrapper 
      [productId]="productId" 
      [showContent]="false"
      [forceHide]="true"
      id="surveySelector" 
      (currentSurveySetted)="onSurveysLoaded($event)">
    </mh-core-lib-survey-wrapper>

    <mh-chain-executive
      [currentDates]="currentDates"
      [productId]="productId"
      [metrics]="filters"
      [chain]="chain"
      [filterSelected]="filterSelected"
      [filtersAreas]="filtersAreas"
      [surveysReady]="surveysReady"
      (areasAvailable)="onAreasAvailable($event)"
      (filterChangeNeeded)="onFilterChangeNeeded()"
      *ngIf="fidelityPermisions.includes('interchain_executive_summary_result')"></mh-chain-executive>
  </mh-box-element>

</mh-alerts-wrapper>
